import { Component, input, output } from "@angular/core";
import { NgStyle } from "@angular/common";
import { ClozeTestStyleModel } from '../model/cloze-test-style-model';

@Component({
  selector: "cloze-test-introduction",
  templateUrl: "./introduction.component.html",
  standalone: true,
  styleUrls: ["./introduction.component.scss"],
  imports: [NgStyle],
})
export class IntroductionComponent {
  readonly title = input("");
  readonly subtitle = input("");
  readonly content = input("");
  readonly clozeTestStyleModel = input({} as ClozeTestStyleModel);
  readonly cTestLogo = input("");
  readonly cTestButtonColor = input("");
  readonly mobileMode = input(false);
  readonly totalExercise = input(0);
  readonly currentExerciseNumber = input(0);
  readonly showExerciseExample = input(false);
  readonly lang = input("de");

  readonly startTest = output<boolean>();
  readonly startTestExample = output<void>();

  toggleStartTest(): void {
    if (this.showExerciseExample()) {
      this.startTestExample.emit();
    } else {
      this.startTest.emit(true);
    }
  }

  toggleStartTestExample(): void {
    if (this.showExerciseExample()) {
      this.startTestExample.emit();
    } else {
      this.startTest.emit(true);
    }
  }
}
